import { localeTag, translate, type Locale } from "../../shared/translations";

export function formatLastActive(
  value: number,
  locale: Locale,
  now = Date.now(),
  compact = false,
) {
  const minutes = Math.max(0, Math.floor((now - value) / 60_000));
  if (minutes === 0) return translate("الآن", locale);
  if (minutes < 60) {
    const relative = new Intl.RelativeTimeFormat(localeTag(locale), {
      style: compact ? "short" : "long",
    }).format(-minutes, "minute");
    return relative;
  }

  const date = new Date(value),
    today = new Date(now);
  const time = new Intl.DateTimeFormat(localeTag(locale), {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
  if (date.toDateString() === today.toDateString())
    return compact ? time : translate("اليوم الساعة {time}", locale, { time });

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString())
    return translate(compact ? "أمس، {time}" : "أمس الساعة {time}", locale, {
      time,
    });

  const day = new Intl.DateTimeFormat(localeTag(locale), {
    day: "numeric",
    month: compact ? "short" : "long",
    ...(date.getFullYear() !== today.getFullYear()
      ? { year: "numeric" as const }
      : {}),
  }).format(date);
  if (compact) return day;
  return translate("{date} الساعة {time}", locale, {
    date: day,
    time,
  });
}
